import { deleteRequest, get, post, put } from "utils/api";

export const getEmailList = async params => {
  const response = await get("/notifications/emails", params);
  return response.data;
};

export const addEmail = async data => {
  const response = await post("/notifications/emails", data);
  return response.data;
};

export const deleteEmail = async id => {
  const response = await deleteRequest(`/notifications/emails/${id}`);
  return response.data;
};

export const getAlertConfiguration = async data => {
  const response = await get("/notifications/configuration", data);
  return response.data;
};

export const saveAlertConfiguration = async data => {
  const response = await post("/notifications/configuration", data);
  return response.data;
};

export const getNotificationSettings = async () => {
  const resposne = await get("/notifications/configuration");
  return resposne.data;
};

export const saveSenderEmailConfig = async ({ senderId, emails }) => {
  const response = await post("/notifications/configuration", {
    inbound: { senderId, emails }
  });
  return response.data;
};

export const deleteSenderEmailConfig = async senderId => {
  const response = await deleteRequest(`/notifications/inbound/${senderId}`);
  return response.data;
};

export const savePaymentEmailConfig = async emails => {
  const response = await post("/notifications/configuration", {
    payment: emails
  });
  return response.data;
};

export const saveOptoutEmailConfig = async emails => {
  const response = await post("/notifications/configuration", {
    optOut: emails
  });
  return response.data;
};

export const deletePaymentEmail = async email => {
  return await put("/notifications/payment", { email });
};

export const deleteOptOutEmail = async email => {
  return await put("/notifications/optOut", { email });
};

export const deleteAllInbound = async inboundStatus => {
  return await put("/notifications/inboundStatus", { inboundStatus });
};

export const updateInbound = async (senderId, emails) => {
  return await put(`/notifications/inbound/${senderId}`, { emails });
};
